import React, { memo } from 'react'
import { BookAppointmentContainer } from './book-appointment-container'

export const BookAppointmentSkeleton = memo(() => {
  return (
    <BookAppointmentContainer>
      Skeleton
    </BookAppointmentContainer>
  )
})
